import autoTable from "jspdf-autotable";
import { PDFCOLORSHEME } from "../../../../../../component/constent";

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function drawGrandTotal(doc, totals) {
 let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY +5
    : 35;

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 40) {
    doc.addPage();
    startY = 35;
  }


 autoTable(doc, {
  startY,
  theme: "grid",
  tableWidth: 175, // Total table width

  body: [[
    "GRAND TOTAL",
    format(totals.direct),
    format(totals.oncost),
    format(totals.total),
    "",
    
  ]],

  styles: {
    fontSize:PDFCOLORSHEME.FONT_SIZE_GRAND_TOTAL,
    cellPadding: 2,
    halign: "right",
    textColor:PDFCOLORSHEME.FONT_COLOR_GRAND_TOTAL
  },

  columnStyles: {
    0: {
      cellWidth: 30,   // GRAND TOTAL
      halign: "left",
      fontStyle: "bold",
    },
    1: {
      cellWidth: 30,   // Debit
      halign: "right",
    },
    2: {
      cellWidth: 30,   // Credit
      halign: "right",
    },
    3: {
      cellWidth: 30,   // Credit
      halign: "right",
    },

    4: {
      cellWidth: 55,   // Credit
      halign: "right",
    },

  },

  didParseCell(data) {
    if (data.section === "body") {
      data.cell.styles.fontStyle = "bold";
      data.cell.styles.fillColor = PDFCOLORSHEME.BACK_COLOR_GRAND_TOTAL;
      
    }
  },
});
}